/*global document, jQuery */
/*jslint indent: 4, maxlen: 80, multistr: true */

(function ($) {
    "use strict";

    $(document).ready(function () {
        var body = $('body');
        // show help icons next to titles


        function asHelpLink(s) {
            return "&nbsp;<a href='" + s + "' target='_blank'>" +
                "<i class='far fa-question-circle fa-sm text-black-50' value='Read the help article for more information.' data-toggle='tooltip' data-placement='top' title='Read the help article for more information.'></i></a>";
        }

        // Inject help
        $(".BlogAdd #content > h1").append(
            asHelpLink('https://help.easyblognetworks.com/article/184-add-blog'));
        $(".BlogView #dns_info_title").append(
            asHelpLink('https://help.easyblognetworks.com/article/185-set-up-dns'));
        $(".BlogView #backup_card_title").append(
            asHelpLink('https://help.easyblognetworks.com/article/206-my-backup-and-migration-plugin-is-not-working'));
        $(".BlogView #seo_metrics_title").append(
            asHelpLink('https://help.easyblognetworks.com/article/243-why-are-seo-metrics-different-than-live'));
        $(".BlogView #recent_activity_title").append(
            asHelpLink('https://help.easyblognetworks.com/article/188-activity-page'));
        $(".audit_log #content > h1").append(
            asHelpLink('https://help.easyblognetworks.com/article/188-activity-page'));


        function toDateString(d) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('/');
        }

        // Format datetime
        $(".datetime-static-short").each(function (_, obj) {
            var d = new Date(obj.innerHTML);
            obj.innerHTML = toDateString(d);
        });
        $(".datetime-static-long").each(function (_, obj) {
            var d = new Date(obj.innerHTML);
            obj.innerHTML = toDateString(d) + ' ' + d.toLocaleTimeString();
        });

        // Happy copy method
        var cp = new Clipboard('.copy-me', {
            text: function (trigger) {
                return trigger.getAttribute('data-value');
            }
        });
        cp.on('success', function (e) {
            e.clearSelection();
            showTooltip(e.trigger, 'Copied!');
        });

        cp.on('error', function (e) {
            showTooltip(e.trigger, fallbackMessage(e.action));
        });

        $('.copy-me').each(function () {
            var e = $(this);
            var input = e.parent().prev();
            if (!input.length) {
                return;
            }
            var pw = new Array(e.attr('data-value').length).join("*");
            if (!input.val().length) {
                input.val(pw);
            }
        });

        $('.copy-me').on('mouseleave', function (e) {
            $(e.currentTarget).removeAttr('data-original-title');
            $(e.currentTarget).removeAttr('title');
            $(e.currentTarget).tooltip('dispose');
        });

        function showTooltip(elem, msg) {
            var e = $(elem);
            e.attr('data-original-title', msg);
            e.attr('title', msg);
            e.tooltip('show');
            var input = e.parent().prev();
            if (input.length) {
                input.val(e.attr('data-value'));
            }
        }

        function fallbackMessage(action) {
            var actionMsg = '';
            var actionKey = (action === 'cut' ? 'X' : 'C');

            if (/iPhone|iPad/i.test(navigator.userAgent)) {
                actionMsg = 'No support :(';
            }
            else if (/Mac/i.test(navigator.userAgent)) {
                actionMsg = 'Press ⌘-' + actionKey + ' to ' + action;
            }
            else {
                actionMsg = 'Press Ctrl-' + actionKey + ' to ' + action;
            }

            return actionMsg;
        }


        // [karantan]: Why do we have this code???
        // Prevent submit button after first click
        // body.on(
        //     'submit',
        //     'form',
        //     function () {
        //         var that = $(this);
        //         that.find('input[type=text]').prop('readonly', true);
        //         that.find('input[type=password]').prop('readonly', true);
        //         setTimeout(function () {
        //             that.find('button[type=submit]').prop('disabled', true);
        //         }, 10);
        //     }
        // );

        $("form .btn-upgrade").click(function (e) {
            var $button = $(this),
                $form = $(this).closest("form");

            e.preventDefault();

            bootbox.dialog({
                message: $button.attr('value'),
                buttons: {
                    success: {
                        label: 'Upgrade Now',
                        className: "btn-success",
                        callback: function (result) {
                            if (result) {
                                // the jquery submit() does not include the
                                // button in the POST so we have to manually
                                // append it
                                $('<input />').attr('type', 'hidden')
                                    .attr('name', $button.attr('name'))
                                    .attr('value', $button.attr('value'))
                                    .appendTo($form);

                                $form.submit();
                            }
                        }
                    },
                    cancel: {
                        label: 'Cancel',
                        className: "btn-danger",
                        callback: function () {
                        }
                    }
                }
            });
        });

        // JS for action confirmation prompt
        $(".confirmation-prompt input.confirmation").keyup(function() {
            if($(this).data("validate") === $(this).val()) {
                $('.confirmation-prompt button[type="submit"]').removeAttr(
                    "disabled");
            }
            else {
                $('.confirmation-prompt button[type="submit"]').attr(
                    "disabled", "disabled");
            }
        });
        $(".confirmation-prompt").on("show.bs.modal", function () {
            $(".confirmation-prompt input.confirmation").val("");
            $('.confirmation-prompt button[type="submit"]').attr(
                "disabled", "disabled");
        });

        // Close modal after form is submitted to prevent double submittions
        $('#deleteImmediately form').submit(function() {
            $('#deleteImmediately').modal('hide')
            return true;
        });

        // JS code for views/blog.py#report_problem
        var searchParams = new URLSearchParams(window.location.search);
        if (searchParams.get('report-problem') === "show") {
            $('#problem').modal('show');
        }
        $("#report_problem form input[name=action]").on('change', function(){
            var type = $(this).val();
            var other_text = $("#report_problem form #other_text");
            var zoho = $("#report_problem form #zoho_config");
            var dkim_dmarc = $("#report_problem form #dkim_dmarc");
            var notification = $("#report_problem form #auto");
            var button = $("#report_problem form button");
            if(type == "other"){
                notification.hide();
                other_text.show();
                zoho.hide();
                dkim_dmarc.hide();
                other_text.removeAttr("disabled");
                other_text.attr("required", "required");
                button.removeAttr("disabled");
                button.text("Report My Problem");
                button.show();
            }else if (type=="noop"){
                other_text.hide();
                zoho.hide();
                dkim_dmarc.hide();
                button.hide();
                notification.text($(this).parent().data("msg"));
                notification.show();
            }else if (type=="reset_password"){
                other_text.hide();
                zoho.hide();
                dkim_dmarc.hide();
                notification.hide();
                other_text.attr("disabled", "disabled");
                other_text.removeAttr("required");
                button.removeAttr("disabled");
                button.text("Reset Password");
                button.show();
            }else if (type=="zoho"){
                zoho.show();
                dkim_dmarc.hide();
                other_text.hide();
                other_text.attr("disabled", "disabled");
                notification.hide();
                button.removeAttr("disabled");
                button.text("Submit records");
                button.show();
            }else if (type=="dkim"){
                dkim_dmarc.show();
                zoho.hide();
                other_text.hide();
                other_text.attr("disabled", "disabled");
                notification.hide();
                button.removeAttr("disabled");
                button.text("Submit records");
                button.show();
            }else{
                other_text.hide();
                zoho.hide();
                dkim_dmarc.hide();
                notification.hide();
                other_text.attr("disabled", "disabled");
                other_text.removeAttr("required");
                button.removeAttr("disabled");
                button.text("Try Automated Fix");
                button.show();
            }
        });

    });
}(jQuery));  // jshint ignore:line
